import request from "@/router/axios";

export const homeStatisticsList = (businessDeptId, type) => {
    return request({
        url: "/api/yourong-app/home/home-statistics-list",
        method: "get",
        params: {
            businessDeptId,
            type,
        },
    });
};

//home-statistics-month-list
export const homeStatisticsMonthList = (businessDeptId, type) => {
    return request({
        url: "/api/yourong-app/home/home-statistics-month-list",
        method: "get",
        params: {
            businessDeptId,
            type,
        },
    });
};

//tree-data-scope
export const treeDataScope = () => {
    return request({
        url: "/api/yourong-app/home/tree-data-scope",
        method: "get",
    });
};

//company-business-reports
export const companyBusinessReports = (type, businessDeptId) => {
    return request({
        url: "/api/yourong-app/home/company-business-reports",
        method: "get",
        params: {
            type,
            businessDeptId
        },
    });
};

///home-statistics-loan-page
export const homeStatisticsLoanPage = ({ type, dataType, dataTypeValue, businessDeptId }) => {
    return request({
        url: "/api/yourong-app/home/home-statistics-loan-page",
        method: "get",
        params: {
            type,
            dataType,
            dataTypeValue,
            businessDeptId,
        },
    });
};


///statistics-today
export const statisticsToday = (businessDeptId) => {
    return request({
        url: "/api/yourong-app/home/statistics-today",
        method: "get",
        params: {
            businessDeptId,
        },
    });
};

///statistics-month
export const statisticsMonth = (businessDeptId) => {
    return request({
        url: "/api/yourong-app/home/statistics-month",
        method: "get",
        params: {
            businessDeptId,
        },
    });
};


// 首页-租后数据日统计
export const homeStatisticsDaily = (businessDeptId) => {
    return request({
        url: "/api/blade-loanPost/statistics/home-statistics-daily",
        method: "post",
        data: {
            businessDeptId,
        },
    });
};
// 首页-租后数据月统计
export const homeStatisticsMonth = (businessDeptId) => {
    return request({
        url: "/api/blade-loanPost/statistics/home-statistics-month",
        method: "post",
        data: {
            businessDeptId,
        },
    });
};

//首页-日数据统计列表-只返回30天数据
export const homeDailyStatisticsList = (businessDeptId, type) => {
    return request({
        url: "/api/blade-loanPost/statistics/home-daily-statistics-list",
        method: "get",
        params: {
            businessDeptId,
            type
        },
    });
};
//首页-月数据统计列表-只返回12个月数据
export const homeMonthStatisticsList = (businessDeptId, type) => {
    return request({
        url: "/api/blade-loanPost/statistics/home-month-statistics-list",
        method: "get",
        params: {
            businessDeptId,
            type
        },
    });
};
// 各分公司还款情况报表
export const deptRepaymentStatus = (dateType) => {
    return request({
        url: "/api/blade-loanPost/statistics/deptRepaymentStatus",
        method: "post",
        data: (function(dateType) {
            var form = new FormData();
            form.append("dateType", dateType);
            return form;
        })(dateType),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
    });
};

// 首页-代偿统计
export const compensationCount = () => {
    return request({
        url: "/api/blade-compensation/compensationManagement/compensationCount",
        method: "post"
    });
};

//首页数据统计
export const statisticsList = (businessDeptId) => {
  return request({
      url: "/api/yourong-app/home/statistics",
      method: "get",
      params: {
          businessDeptId,
      },
  });
};

//各分公司业绩报表
export const companyBusinessReports2 = (current,size) => {
  return request({
      url: "/api/yourong-app/home/company-business-reports2",
      method: "get",
      params:{
        current,
        size
      }
  });
};
